import React from "react";
import {
  Row,
  Col,
  Accordion
} from "react-bootstrap";
import cx from "classnames";
import Timeago from "react-timeago";
import _ from "lodash";

import { FileService } from "src/services/file.service";
import Truncate from "src/components/truncate";
import AssetShareView from "../contactAssetShare";
import SectionShareView from "../sectionShare/view";

import styles from "./styles.module.scss";

class SharesView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loadAnalytics: false,

      viewMore: false,
    };

    this._handleShareClicked = this._handleShareClicked.bind(this);
  }

  fetchAssetAnalytics(sectionID, asset) {

    this.props.fetchAssetAnalytics(this.props.share.id, sectionID, asset.id).then(() => {
      if (FileService.hasPageAnalytics(asset.metadata)) {
        if (this.props.preview && this.props.preview.item) {
          return;
        }

        this.props.fetchPreviewAsset(asset.id);
      }
    });
  }

  componentDidMount() {
    this.props.fetchShare(this.props.id).then(() => {
      this.props.fetchShareRecipients(this.props.id, 0)
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.setState({
        loadAnalytics: false,
      });
    }
  }

  _handleShareClicked() {
    if (this.props.conversation.item && this.props.conversation.item.fetched) {
      return;
    }

    this.props.fetchShareAssets(this.props.id)

  }

  _formatPercentage(percent) {
    percent = percent || 0;
    percent = percent * 100;
    percent = percent.toFixed(0);
    if (percent > 100) {
      percent = 100;
    }

    return percent + '%';
  }

  render() {
    if (!this.props.share) {
      return false;
    }

    let timeSpent = this.props.share.totalTimeSpent;
    let minutes = this.padNumber(Math.floor(timeSpent / 60), 2);
    let seconds = this.padNumber(Math.floor(timeSpent % 60), 2);

    let conversation = this.props.conversation && this.props.conversation.item;

    var header = (
      <Row className={styles.share} onClick={() => {
        this.setState({ viewMore: !this.state.viewMore });
      }}>
        <Col md={8} className={styles.name}>
          <div className={styles.icon}>
            {this.state.viewMore ? (
              <span className="paperflite-minus" aria-hidden="true" />
            ) : (
              <span className="paperflite-add" aria-hidden="true" />
            )}
          </div>

          <div className={styles.rightTopContainer}>
            <div className={styles.horizontalFlexContainer}>
              <div className={styles.flexContainer}>
                <div className={styles.sharedDate}>
                  Shared <Timeago date={this.props.share.createdDate} />
                </div>
                <Truncate lines={1} width={300} className={styles.subject}>
                  {this.props.share.subject || "(No Subject)"}
                </Truncate>
                <br />
                <div className={styles.assetsCount}>
                  {conversation && conversation.recipients.items && conversation.recipients.items.length > 0 &&
                    <Truncate lines={2} className={styles.recipientName}>{_.get(conversation.recipients.items[0], "item.contact.firstName")}</Truncate>
                  }
                  {conversation && conversation.recipients.items && conversation.recipients.items.length > 1 &&
                    <span className={styles.recipientCount}> +{this.props.share.totalRecipients - 1} more</span>
                  }
                </div>
              </div>
              <a
                target="_blank"
                href={`/conversations/${this.props.share.id}`}
                className={styles.previewConversationContainer}
              >
                <div className={styles.previewConversation}>
                  <i className={cx("paperflite-eye", styles.previewIcon)} />
                  PREVIEW
                </div>
              </a>
            </div>
          </div>
        </Col>

        <div className={styles.rightBottomContainer}>
          <div className={cx(styles.openRate, { [styles.disabled]: this.props.share.uniqueEmailOpens == 0 })}>
            <span className={styles.conversationMetrics}>
              <span className={cx("paperflite-mail-open", styles.metricsIcon)}></span>
              {this._formatPercentage((this.props.share.uniqueEmailOpens / this.props.share.totalRecipients), this.props.share)}
            </span>
          </div>
          <div className={cx(styles.clickRate, { [styles.disabled]: this.props.share.uniqueLinkClicks == 0 })}>
            <span className={styles.conversationMetrics}><span className={cx("paperflite-click-rate", styles.metricsIcon)}></span>{this._formatPercentage((this.props.share.uniqueLinkClicks / this.props.share.totalRecipients), this.props.share)}</span>
          </div>
          <div className={cx(styles.timeSpent, { [styles.disabled]: this.props.share.totalTimeSpent == 0 })}>
            <span className={styles.conversationMetrics}><span className={cx("paperflite-share", styles.metricsIcon)}></span>{`${minutes}:${seconds}`}</span>
          </div>
        </div>
      </Row>
    );

    return (
      <Accordion className={styles.accordion}>
        <Accordion.Item eventKey="0">
          <Accordion.Header className={styles.accordionHeader} onClick={this._handleShareClicked}><Row className={styles.headerContainer}>
            <Col xl={12}>
              {header}
            </Col>
          </Row>
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordionBodyWrapper}>{this._renderChildren()}</div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }

  _renderChildren() {
    let conversationItem = this.props.conversation && this.props.conversation.item;
    let error = this.props.conversation && this.props.conversation.error && this.props.conversation.error.errors;

    if (!error && this.props.conversation && this.props.conversation.loadingAssets) {
      return <div className={styles.loading}>Loading details...</div>;
    }

    if (error) {
      return <div className={styles.loading}>You are not allowed to view this content</div>
    }

    if (conversationItem && conversationItem.sections.length > 0) {
      return this._renderSections(conversationItem.sections);
    } else if (conversationItem && conversationItem.assets.length > 0) {
      return this._renderAssets(conversationItem.assets);
    }
  }

  _renderSections(shareSections) {
    var sections = shareSections.map((section) => {
      return (
        <SectionShareView
          className={styles.section}
          key={section.id}
          shareId={this.props.share.id}
          section={section}
          renderWithin="contact"
          share={this.props.share}
          fetchShareSection={this.props.fetchShareSection}
          fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
        />
      );
    });

    return sections;
  }

  _renderAssets(shareAssets) {
    var assets = shareAssets.map((asset) => {
      return (
        <div>
          <AssetShareView
            key={asset.id}
            shareId={this.props.share.id}
            page={this.props.page}
            asset={asset}
            renderWithin="contact"
            events={asset.events}
            shouldFetchAnalytics={true}
            fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
            showAnalytics={false}
          />
        </div>
      );
    });

    return assets;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default SharesView;